import { calculateDoseIntervalDate } from "@/lib/dose-interval";
import type { DoseIntervalLike } from "@/lib/dose-interval";

export type ApplicationDoseSuggestionInterval = DoseIntervalLike & {
  next_application_item_id?: string | null;
};

export type ApplicationDoseSuggestion = {
  itemId: string;
  dueDate: Date;
};

export const buildApplicationDoseSuggestions = (
  intervals: ApplicationDoseSuggestionInterval[] | null | undefined,
  baseDate: Date | string | null | undefined,
  fallbackItemId: string | null | undefined,
): ApplicationDoseSuggestion[] => {
  const parsedBaseDate = baseDate instanceof Date ? baseDate : baseDate ? new Date(baseDate) : null;
  if (!parsedBaseDate || Number.isNaN(parsedBaseDate.getTime())) return [];

  return (intervals ?? []).flatMap((interval) => {
    const dueDate = calculateDoseIntervalDate(parsedBaseDate, interval);
    const itemId = interval.next_application_item_id?.trim() || fallbackItemId?.trim();
    return dueDate && itemId ? [{ itemId, dueDate }] : [];
  });
};
